import { render, staticRenderFns } from "./ColumnWrapperElement.vue?vue&type=template&id=4edfad3c&"
import script from "./ColumnWrapperElement.vue?vue&type=script&lang=js&"
export * from "./ColumnWrapperElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports